export default "__VITE_ASSET__c3f86994__"